<template>
	<div>
		<dv-full-screen-container class="full">
			<div class="button">
				<el-button icon="el-icon-close" circle @click="retura"></el-button>
			</div>
			<div style="display: flex;justify-content: space-between;height: 100px;align-items: center;">
				<div
					class="heading"
					style="">
					民警健康可视化分析
				</div>
				<div class="time" style="font-size: 20px">
					最近一次体检时间：{{myData?myData.createTime:''}}
				</div>
			</div>
			<div class="nav">
				<div class="left">
					<left></left>
				</div>
				<div style="flex-grow: 1">
					<middle></middle>
				</div>
				<div class="right">
					<right></right>
				</div>
			</div>
			<div style="text-align:center;color: white;font-size: 20px">
				<span>版权：学堂公安教育训练网络学院</span>
				<span style="margin-left: 50px;">技术支持：深圳市学堂科技有限公司</span>
			</div>
		</dv-full-screen-container>
	</div>
</template>
<script>
import Map from './user/map.vue';
import Left from './user/left.vue';
import Right from "./user/right.vue";
import Middle from "./user/middle.vue";
import {PeoAnalyse} from "@/api/personcenter";

var echarts = require('echarts');

export default {
	components: {
		Middle,
		Right,
		MyMap: Map,
		Left,
	},
	data() {
		return {
			user: JSON.parse(this.$store.state.User.infos),
			myData: null,
		};
	},
	created() {
		this.getList();
	},
	mounted() {
	},
	methods: {
		getList() {
			PeoAnalyse({userId:this.user.id}).then(res => {
				console.log(res.result);
				let data = res.result;
				this.myData = data;
			})
		},
		retura() {
			this.$emit('close');
		},
	},
};
</script>
<style scoped lang="scss">
.heading {
	font-size: 36px;
	color: #4CC2C3;
	margin-left: 100px;
}

.time {
	color: white;
	display: flex;
	align-items: flex-end;
	margin-right: 260px;
	img {
		width: 30px;
		height: 30px;
	}
	.hour {
		font-size: 36px;
		line-height: 28px;
	}
	.seconds {
		font-size: 20px;
		border-bottom: 2px solid #38FB76;
		margin-left: 6px;
	}
}

.button {
	height: 0;
	position: relative;
	left: 93%;
	top: 10px;
}

.full {
	background-image: url('/img/20220328.png');
	background-size: contain;
}

.header1 {
	display: flex;
	padding: 20px;
	justify-content: space-between;
	text-align: center;
}

.nav {
	display: flex;
}

.left {
	width: 30%;
}

.right {
	width: 28%;
	height: 500px;
}
</style>